import { MenuItem, Checkbox } from "@mui/material";
import React from "react";
import { checkIndeterminate, checkBaseCheckbox } from "./helpers";
import { OptionType } from "../../../services/helpers/types";
import { ValueObjectType } from "../../organisms/CascaderField/helpers";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

interface CascaderOptionItemProps {
  option: OptionType;
  currentValueObject: ValueObjectType;
  onSubSelectOpen: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    option: OptionType
  ) => void;
  onBaseOptionSelect: (option: OptionType) => void;
}

const CascaderOptionItem = (props: CascaderOptionItemProps) => {
  const { option, currentValueObject, onSubSelectOpen, onBaseOptionSelect } =
    props;
  return (
    <MenuItem className="dui-cascader-item">
      <div
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onSubSelectOpen(event, option);
        }}
        className="dui-cascader-item-inner"
      >
        <div>
          <Checkbox
            indeterminate={checkIndeterminate(option, currentValueObject)}
            checked={checkBaseCheckbox(option, currentValueObject)}
            onClick={() => {
              onBaseOptionSelect(option);
            }}
          />
          {option.name}
        </div>
        {option.subOptions !== undefined ? <KeyboardArrowRightIcon /> : null}
      </div>
    </MenuItem>
  );
};

export default CascaderOptionItem;
